import { toArray } from '@wix/wow-utils';
const name = 'BaseObjectProps';
const properties = {};
function animate(kit, objects, duration = 0, delay = 0, params = {}) {
    objects = toArray(objects);
    const paramsSet = new Set(objects.reduce((acc, object) => acc.concat(Object.keys(object)), []));
    const allowedParams = Array.from(paramsSet);
    return kit.engine.tween(objects, { duration, delay, ...params }, allowedParams);
}
export { name, properties, animate };
//# sourceMappingURL=baseObjectProperties.js.map